<template>
  <div>
    <vs-card
      :style="{
        'background-image':
          'url(' +
          require('@/assets/images/i-APC/bg_floor_' + floorIndex + '.png') +
          ')',
      }"
      class="content-card"
    >
      <vs-row vs-w="12">
        <vs-col vs-w="8" vs-lg="8" vs-sm="12" vs-xs="12">
          <h3 id="title-floor" >{{ title }}</h3>
          <!-- <vs-row>
            <vs-icon
              icon="device_thermostat"
              size="40px"
              color="#6FDA79"
            ></vs-icon>
            <h5 class="mt-2">+25°C</h5>
            <p class="mt-2 ml-2">Room Temperature</p>
          </vs-row> -->
          <br />
          <div class="flex-device">
            <div v-for="(item,i) in numDevice.light" :key="i">
              <BtnLight :device_id="item"/>
            </div>
            <div v-for="(item,i) in numDevice.breaker" :key="i">
              <BtnBreaker :device_id="item"/>
            </div>
            <div v-for="(item,i) in numDevice.air" :key="i">
              <BtnAir :device_id="item"/>
            </div>
          </div>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-lg="4"
          vs-sm="0"
          vs-xs="0"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <img
            :src="require('@/assets/images/i-APC/' + floorIndex + '.png')"
            width="100%"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>
<script>
import BtnAir from "./BtnAir.vue";
import BtnLight from "./BtnLight.vue";
import BtnBreaker from "./BtnBreaker.vue";


export default {
  props: {
    title: {
      type: String,
    },
    floorIndex: {
      type: Int32Array,
    },
    numDevice: {
      type: Object,
    },
  },
  components: {
    BtnLight,
    BtnAir,
    BtnBreaker,
  },
  mounted() {
    console.log("numDevice",this.numDevice);
    console.log("bg card", this.bgcard, typeof this.bgcard);
    console.log("floor", this.floorIndex, typeof this.floorIndex);
    // document.getElementById('imgCardFloor').src= "../../../../../assets/images/i-APC/"+this.floorIndex+".png"
  },
  methods: {
    toFloor() {
      console.log("click push to floor");
      this.$router.push({
        name: "I-APC-Floor",
        params: {
          index: this.floorIndex - 1,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
}
.content-card {
  // position: absolute;
  // top: 0%;

  border-radius: 20px;
  background-image: url("../../../../../../assets/images/i-APC/bg_floor_2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .flex-device {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
  }
  p {
    font-size: 0.7rem;
  }
}

#title-floor {
  cursor: pointer;
  &:hover{
    // background: chartreuse;
    color: #6FDA79;
  }
}
</style>